import '../styles/FooterComponent.css';
import { Link } from 'react-router-dom';

const FooterComponent = ({footerContent}) => {
    return (
        <div className="footer" id="copyright-text" style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
            <p id="p-copyright" >{footerContent.text}
                <Link
                    to="/termeni-conditii"
                >
                    {footerContent.terms}
                </Link>
            </p>
        </div>
    )
}

export default FooterComponent;